import "./ContactBanner.scss";

const ContactBanner = () => {
  return (
    <div className="contact-banner">
      Get in touch with us: <span>&#128222;</span>
      <span className="phone-number">18002121799</span>
    </div>
  );
};

export default ContactBanner;
